export const FORM_TITLE_LINES = ['Reset'];
